var map = {
	"./angpao.webp": 2216,
	"./bonus.webp": 2217,
	"./gpi-rebate-m.webp": 2218,
	"./gpi-rebate.webp": 2219,
	"./hublot-watch-2018.webp": 2220,
	"./hublot-watch-2022.webp": 2221,
	"./iphone-13-pro-max.webp": 2222,
	"./iphone-14-pro-max.webp": 2223,
	"./login-to-m.webp": 2224,
	"./login-to.webp": 2225,
	"./mb.webp": 2226,
	"./mg-rebate-m.webp": 2227,
	"./mg-rebate.webp": 2228,
	"./np.webp": 2229,
	"./pointer.webp": 2230,
	"./pp-rebate-m.webp": 2231,
	"./pp-rebate.webp": 2232,
	"./sadface.webp": 2233,
	"./wallet-m.webp": 2234,
	"./wallet.webp": 2235,
	"./wheel-b.webp": 2236,
	"./wheel-btn.webp": 2237,
	"./wheel-indon-b.webp": 2238,
	"./wheel-indon.webp": 2239,
	"./wheel.webp": 2240
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 900;